import React from "react";

interface BadgeProps {
  text: string;
  disabled?: boolean;
  className?: string;
  bgColor?: string; // Optional prop for background color
  textColor?: string; // Optional prop for text color
}

const Badge: React.FC<BadgeProps> = ({
  text,
  disabled,
  className,
  bgColor = "bg-light-blue", // Default background color
  textColor = "text-white", // Default text color
}) => {
  return (
    <div
      className={`inline-block h-full w-10 py-1 text-center rounded-[20px] font-bold text-xs ${
        !disabled ? `${bgColor} ${textColor}` : "bg-gray-600 text-white"
      } ${className}`}
    >
      {text}
    </div>
  );
};

export default Badge;
